import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { ValuationPageDataService } from "src/app/valuation-page/valuation-page-data.service";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import {
  ValuationHeaderInfoState,
  NAVHeaderInfoState,
  ApiResponse,
} from "src/app/valuation-page/valuation-page.model";
import { MONTH_DATE_ABB_YEAR_FORMAT } from "src/app/common-constants";
dayjs.extend(advancedFormat);

/**
 * This component represents "Company's valuation information header"
 * This displays various information about the ticker
 */
@Component({
  selector: "app-valuation-info-header",
  templateUrl: "./valuation-info-header.component.html",
  styleUrls: ["./valuation-info-header.component.scss"],
})
export class ValuationInfoHeaderComponent implements OnInit {
  @Input() showGlobalSettingsButton = false;
  @Input() callForNAV = false;
  data;
  valuationData: ValuationHeaderInfoState;
  navData: NAVHeaderInfoState;
  routeParamSubscriber: Subscription;
  isHeaderDataReady = false;
  legacyUrl = `${window.caUrl}/home`;

  constructor(
    private route: ActivatedRoute,
    private dataService: ValuationPageDataService,
  ) {}

  /**
   * Executes on initial render
   * On router change, it takes current ticker from route and make request to api to get the information about ticker
   * It redirects to home page if user has no access to valuation
   */
  ngOnInit(): void {
    this.isHeaderDataReady = false;
    this.routeParamSubscriber = this.route.params.subscribe((paramData) => {
      const ticker = paramData.ticker
        ? paramData.ticker.toUpperCase()
        : undefined;
      this.dataService
        .getValuationHeaderData(ticker, this.callForNAV)
        .subscribe((response: ApiResponse) => {
          if (response.status === "success") {
            if (this.callForNAV) {
              this.navData = response.data;
              this.data = {
                ...this.navData,
                last_date: response.data.last_date
                  ? dayjs(response.data.last_date).format(
                      MONTH_DATE_ABB_YEAR_FORMAT,
                    )
                  : undefined,
              };
            } else {
              this.valuationData = response.data;

              this.data = {
                ...this.valuationData,
                last_date: response.data.last_date
                  ? dayjs(response.data.last_date).format(
                      MONTH_DATE_ABB_YEAR_FORMAT,
                    )
                  : undefined,
              };
            }
            this.isHeaderDataReady = true;
          } else if (
            response.status_code === 403 &&
            window.location.href !== this.legacyUrl
          ) {
            window.location.href = this.legacyUrl;
          }
        });
    });
  }

  ngOnDestroy() {
    if (this.routeParamSubscriber) {
      this.routeParamSubscriber.unsubscribe();
    }
  }
}
